import * as Actions from './notification-group.actions';
import { Action } from '@ngrx/store';
import { INotificationGroupDataState } from './notification-group.model';

export const notificationGroupDataState: INotificationGroupDataState = {
  notificationGroupDataLoading: false,
  notificationGroupDataLoaded: false,
  notificationGroupData: null,
  notificationGroupAddModalDataLoading: false,
  notificationGroupAddModalDataLoaded: false,
  notificationGroupAddModalData: null,
  notificationGroupEditModalDataLoading: false,
  notificationGroupEditModalDataLoaded: false,
  notificationGroupEditModalData: null,
  notificationGroupRecipientInfoLoading: false,
  notificationGroupRecipientInfoLoaded: false,
  notificationGroupRecipientInfoData: null,
  notificationGroupAddLoading: false,
  notificationGroupAddCompleted: false,
  notificationGroupAddCompletedData: null,
  notificationGroupEditLoading: false,
  notificationGroupEditCompleted: false,
  notificationGroupEditCompletedData: null,
};

export function notificationGroupReducer(
  state: INotificationGroupDataState = notificationGroupDataState,
  baseAction: Action,
): INotificationGroupDataState {
  const action = baseAction as Actions.NotificationGroupActions;

  switch (action.type) {
    case Actions.NOTIFICATION_GROUP_DATA_LOADING:
      return {
        ...state,
        notificationGroupData: null,
        notificationGroupDataLoading: true,
        notificationGroupDataLoaded: false,
      };
    case Actions.NOTIFICATION_GROUP_DATA_LOADED:
      return {
        ...state,
        notificationGroupData: action.payload,
        notificationGroupDataLoading: false,
        notificationGroupDataLoaded: true,
      };
    case Actions.NOTIFICATION_GROUP_ADD_MODAL_DATA_LOADING:
      return {
        ...state,
        notificationGroupAddModalData: null,
        notificationGroupAddModalDataLoading: true,
        notificationGroupAddModalDataLoaded: false,
      };
    case Actions.NOTIFICATION_GROUP_ADD_MODAL_DATA_LOADED:
      return {
        ...state,
        notificationGroupAddModalData: action.payload,
        notificationGroupAddModalDataLoading: false,
        notificationGroupAddModalDataLoaded: true,
      };
    case Actions.NOTIFICATION_GROUP_EDIT_MODAL_DATA_LOADING:
      return {
        ...state,
        notificationGroupEditModalData: null,
        notificationGroupEditModalDataLoading: true,
        notificationGroupEditModalDataLoaded: false,
      };
    case Actions.NOTIFICATION_GROUP_EDIT_MODAL_DATA_LOADED:
      return {
        ...state,
        notificationGroupEditModalData: action.payload,
        notificationGroupEditModalDataLoading: false,
        notificationGroupEditModalDataLoaded: true,
      };
    case Actions.NOTIFICATION_GROUP_RECIPIENT_INFO_LOADING:
      return {
        ...state,
        notificationGroupRecipientInfoData: null,
        notificationGroupRecipientInfoLoading: true,
        notificationGroupRecipientInfoLoaded: false,
      };
    case Actions.NOTIFICATION_GROUP_RECIPIENT_INFO_LOADED:
      return {
        ...state,
        notificationGroupRecipientInfoData: action.payload,
        notificationGroupRecipientInfoLoading: false,
        notificationGroupRecipientInfoLoaded: true,
      };
    case Actions.NOTIFICATION_GROUP_ADD:
      return {
        ...state,
        notificationGroupAddCompletedData: null,
        notificationGroupAddLoading: true,
        notificationGroupAddCompleted: false,
      };
    case Actions.NOTIFICATION_GROUP_ADD_COMPLETED:
      return {
        ...state,
        notificationGroupAddCompletedData: action.payload,
        notificationGroupAddLoading: false,
        notificationGroupAddCompleted: true,
      };
    case Actions.NOTIFICATION_GROUP_EDIT:
      return {
        ...state,
        notificationGroupEditCompletedData: null,
        notificationGroupEditLoading: true,
        notificationGroupEditCompleted: false,
      };
    case Actions.NOTIFICATION_GROUP_EDIT_COMPLETED:
      return {
        ...state,
        notificationGroupEditCompletedData: action.payload,
        notificationGroupEditLoading: false,
        notificationGroupEditCompleted: true,
      };

    default:
      return state;
  }
}
